import React, { useEffect, useState } from 'react'
import { getValueFromResource } from '../../common/timeLiveFunction'
import { KTSVG } from '../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { ShowAssignmentModal, UpdateToShowModal } from './SchedulerSlice';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';

const AddEmployeeModal = ({ onClose }: any) => {
    const { isShowEmployeeNameWithCode, showEmployeeNameBy } = useAppSelector((state) => state.globalState);
    const { projectData } = useAppSelector((state) => state.scheduler);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [projectEmployees, setProjectEmployees] = useState<any[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('')

    const getTeam = async () => {
        const { parentId, projectId } = projectData;
        const response = await fetchTimeliveAPI(`api/Employee/GetCurrentActiveEmployeesWithSelectedTeam/${parentId ?? projectId}`, `Get`, '', true);
        const json = await response.json();
        const result = json?.Data?.filter((item: any) => item?.AccountProjectEmployeeId === 0)
        setProjectEmployees(result);
    };

    useEffect(() => {
        getTeam();
    }, []);

    const toggleEmployeeInclude = (item: any, id: number) => {
        dispatch(ShowAssignmentModal({ flag: true, ShowAssignmentModal: { ...projectData, AccountEmployeeId: id, name: `${item?.FirstName} ${item?.LastName}`, HoursPerDay: item?.HoursPerDay, clickedDate: new Date() } }));
        dispatch(UpdateToShowModal(false));
        setProjectEmployees(prev =>
            prev.map(emp =>
                emp.AccountEmployeeId === id
                    ? { ...emp, IncludeTeam: emp.IncludeTeam === 0 ? 1 : 0 }
                    : emp
            )
        );
    };

    function getFullName(item: any) {
        const { EmployeeCode, FirstName, LastName, IsDisabled } = item;
        const employeeCodePrefix = isShowEmployeeNameWithCode && EmployeeCode ? `${EmployeeCode} - ` : '';
        if (showEmployeeNameBy === 2 && IsDisabled) {
            return `${employeeCodePrefix}${LastName} ${FirstName} (Disabled)`;
        } else if (showEmployeeNameBy === 2) {
            return `${employeeCodePrefix}${LastName} ${FirstName}`;
        } else if (showEmployeeNameBy === 1 && IsDisabled) {
            return `${employeeCodePrefix}${FirstName} ${LastName} (Disabled)`;
        } else {
            return `${employeeCodePrefix}${FirstName} ${LastName}`;
        }
    }
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm)
        }, 300)

        return () => {
            clearTimeout(handler)
        }
    }, [searchTerm])

    const onHandleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
    }

    const filteredData = projectEmployees?.filter((item: any) => item?.FirstName?.toLowerCase().includes(debouncedSearch.toLowerCase()) || item?.LastName?.toLowerCase().includes(debouncedSearch.toLowerCase()))
    return (
        <>
            <div className="card-body">
                <div className="modal drawer-overlay" style={{ display: 'block' }}>
                    <div className="modal-dialog" style={{ maxWidth: '450px' }}>
                        <div className="modal-content" style={{ maxHeight: '50vh' }}>
                            <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                                <h5 className="modal-title mainHeading">{getValueFromResource('Select Employee', dispatch, t)}</h5>
                                <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </div>
                            </div>

                            <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={onHandleSearch}
                                        placeholder={getValueFromResource('Search', dispatch, t)}
                                        className="form-control h-35px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className="mt-3">
                                    {filteredData?.length > 0 && filteredData.map((item: any) => (
                                        <div
                                            key={item.AccountProjectId}
                                            onClick={() => toggleEmployeeInclude(item, item.AccountEmployeeId)}
                                            className="d-flex px-2 py-2 cursor"
                                            style={{
                                                borderBottom: '1px solid #eff2f5'
                                            }}
                                        >
                                            <div
                                                className='symbol symbol-circle symbol-35px cursor'
                                                onClick={() => toggleEmployeeInclude(item, item.AccountEmployeeId)}
                                            >
                                                {item.AccountProjectEmployeeId === 0 ? (
                                                    <div className='symbol-label fw-bold'
                                                        style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8', color: '#fff', marginRight: 8 }}>
                                                        {`${item.FirstName.charAt(0)}${item.LastName.charAt(0)}`}
                                                    </div>
                                                ) : (
                                                    <div className="symbol symbol-35px me-2">
                                                        <span className="symbol-label bg-light-primary">
                                                            <i className="ki-outline ki-check-circle text-primary fs-1"></i>
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <span
                                                className='cursor mt-3 text-dark'
                                                onClick={() => toggleEmployeeInclude(item, item.AccountEmployeeId)}
                                            >
                                                {getFullName(item)}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                                {filteredData.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {getValueFromResource('No Record Found', dispatch, t)}
                                        </p>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddEmployeeModal;
